export class GaugeMarkerColors {
  static BLUE = '#D8F5FF';
  static GREEN = '#00FF00';
  static YELLOW = '#FFCB02';
  static ORANGE = '#F17D00';
  static RED = '#FF0000';
  static PURPLE = '#9900FF';
  static GRAY = '#6BA6EB';}